import { useContext } from 'react'

import { faCog, faPen } from '@fortawesome/pro-solid-svg-icons'
import { FormControlLabel, Switch, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CoreEmptyState } from '@scoir/empty-state'

import SYSTEM_PERMISSIONS from 'common/system-permissions'
import { useAppSelector } from 'store'
import { hasPermission } from 'store/user'

import IntegrationConfigurationContext from '../IntegrationConfigurationProvider/Context'

const useStyles = makeStyles((theme) => ({
  switch: {
    backgroundColor: theme.palette.pageBackground?.main,
    width: '100%',
    padding: theme.spacing(1),
    margin: theme.spacing(2, 0),
  },
}))

const Handraisers = () => {
  const classes = useStyles()
  const { state, onActivateHandraisersToggle } = useContext(IntegrationConfigurationContext)
  const canManageHandraisers = useAppSelector((state) =>
    hasPermission(state, SYSTEM_PERMISSIONS.VIEW_STUDENT_INTERESTS),
  )

  if (!canManageHandraisers) {
    return (
      <>
        <Typography variant="h6">Handraisers</Typography>
        <CoreEmptyState
          condensed
          icon={faPen}
          title="You don’t have permission to manage Handraisers"
          subTitle="Contact your school’s administrator to grant you the appropriate access."
        />
      </>
    )
  }

  return (
    <>
      <Typography variant="h6">Handraisers</Typography>
      {!state.ConfiguredDeliveryMethod ? (
        <CoreEmptyState
          condensed
          icon={faCog}
          title="Ready to engage interested students?"
          subTitle="Configure your integration to enable nightly delivery of opt-in data."
        />
      ) : (
        <FormControlLabel
          className={classes.switch}
          label="Turn on Handraisers Data Integration"
          control={
            <Switch
              checked={state.HandraiserEnabled}
              onChange={(e) => onActivateHandraisersToggle({ checked: e.target.checked })}
              color="primary"
            />
          }
        />
      )}
    </>
  )
}

export default Handraisers
